import { api } from "@/lib/axios";

type UpdateData = {
  name: string;
  phone: string;
  email?: string;
  project: string;
  landSize: string;
  downPayment: string;
  monthlyPayment: string;
  appointmentDate?: string;
  user?: string;
};

export default function updateOne(id: string, data: UpdateData) {
  return api.put(`leads/${id}`, {
    ...data,
    fullName: data.name,
    campaign: data.project,
    landMeasurement: data.landSize,
    mensuality: data.monthlyPayment,
    hitch: data.downPayment,
    source: "CRM",
  });
}
